import { useTranslation } from 'react-i18next';
import type { ResultFieldConfig } from '../calculator.constants';
import type {
  RedemptionFundResult,
  RedemptionSummary,
} from '../calculator.types';
import { CalculatorResultRow } from './calculatorResultRow';

export const CalculatorResultFields = <
  T extends RedemptionFundResult | RedemptionSummary,
>({
  fields,
  hideWithholdingTax,
  labels,
  options,
  source,
}: {
  fields: ResultFieldConfig<T>[];
  hideWithholdingTax: boolean;
  labels?: Record<string, string>;
  options: Record<string, unknown>;
  source?: Partial<T>;
}) => {
  const { t } = useTranslation('workflowCompletions');

  return (
    <>
      {fields.map((field) => {
        if (field.hideWhenWithholdingTaxHidden && hideWithholdingTax) {
          return null;
        }

        return (
          <CalculatorResultRow
            key={field.fieldKey}
            dividerBefore={field.dividerBefore}
            emphasis={field.emphasis}
            fieldKey={field.fieldKey}
            label={labels?.[field.labelKey] ?? t(field.labelKey)}
            options={options}
            value={source ? field.getValue(source as T) : undefined}
          />
        );
      })}
    </>
  );
};
